import { render } from "./delivery.vue?vue&type=template&id=658b9957"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__